import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
/*
vue 鼠标事件控制台警告:
Added non-passive event listener to a scroll-blocking 'mousewheel' event. Consider marking event handler as 'passive' to make the page more responsive
解决此问题，引入下面的插件
安装命令：npm i default-passive-events -S
*/
import 'default-passive-events'

// 用于ajax请求
import axios from 'axios'
// 用于ajax请求时，格式化数据
import qs from 'qs'
// ElementUI前端框架
import ElementUI from 'element-ui'
import VCharts from 'v-charts'

import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/webapp.css'
import '@/assets/css/fonts.css'

// 引入echarts
// import echarts from 'echarts'

// 自定义函数库，用于判断当前用户的“活跃度”-----是否在操作
import checkActive from './common/checkActive.js'
import funHelper from './common/funHelper.js'
// 解决这个警告：export 'default' (imported as 'regionHelper') was not found in
// 可通过下面注释的代码。具体原因，还需要继续查资料。
// 网络查询的资料显示是：ES6 编译器识别问题。感觉这个原因似乎不全面
// import * as regionHelper from './common/regionHelper.js'
import regionHelper from './common/regionHelper.js'
import loader from './common/loadApisAndRouters.js'

// 打印使用
import printJS from 'print-js'

import _ from 'lodash'
Vue.prototype._ = _

Vue.prototype.$http = axios
Vue.prototype.$qs = qs

Vue.prototype.$print = printJS

// 定义全局引用，后面代码中，可以通过this.$echarts对echarts进行调用
// Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
Vue.use(VCharts)

Vue.config.productionTip = false

// 设置该项，发起ajax请求的时候，才能携带session信息
// 但服务端的Access-Control-Allow-Origin不能为*
axios.defaults.withCredentials = true

// 定义全局的判断用户活跃度的方法
Vue.prototype.$chk = checkActive
Vue.prototype.$fun = funHelper
Vue.prototype.$region = regionHelper
/*
定义全局的退出方法，退出时清空sessionStorage
*/
Vue.prototype.logout = () => {
  // 清除指定的sessionStorage
  sessionStorage.removeItem('authorization')
  sessionStorage.removeItem('operator')
  sessionStorage.removeItem('operator_id')
  sessionStorage.removeItem('menus')
  sessionStorage.removeItem('raw_menus')
  // 清除所有 sessionStorage
  sessionStorage.clear()
  // 退出系统时，将tab菜单，只保留 “控制台”
  store.state.tabs = [
    {
      id: '10000000000000000',
      title: '控制台',
      name: 'dashboard',
      changedName: 'dashboard',
      route: '/dashboard'
    }
  ]
  router.push({
    path: '/'
  })
}

/*
定义全局函数
 */
// 全局loading
let loadingInstance = null
Vue.prototype.setLoading = function (_display) {
  if (_display === 'show') {
    loadingInstance = this.$loading({
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
      customClass: 'app-loading'
    })
    /*
     * loading对象的zIndex样式，是通过计算获得到的，无法通过样式进行修改，也没有对应的属性或方法进行修改
     * 应用中的需求是，要让loading覆盖在所有的页面之上，针对loading的特点，添加了一个自定义的className（app-loading），
     * 通过这个名称，获取loading元素，然后设置zIndex的值为10000，可以满足覆盖在所有元素之上的需求
     */
    let loadingDom = document.getElementsByClassName('app-loading')
    loadingDom[0].style.zIndex = 10000
  } else {
    loadingInstance.close()
  }
}
// 定义服务器访问的根地址
// const ApiRoot = 'http://localhost:5000/'
// 通过在public目录下，建立一个static/js/config.js文件，定义可配置的ip
const ApiRoot = window.g.baseUrl
// 定义访问服务器Api的根路径
Vue.prototype.$apiroot = ApiRoot
// 定义用于访问服务器Api的各个路径
Vue.prototype.$apis = loader.loadApis()

/*
sessionStorage的使用
添加一个sessionStorage
sessionStorage.setItem('token', this.userName)
在任意页面任意方法中获取
sessionStorage.getItem("token")
退出登录时，删除当前的
sessionStorage.removeItem("token")
//清除全部
sessionStorage.clear()
*/

/* 定义全局的ajax方法 */
/*
_contentType 是要区分JSON方式提交，还是form方式提交，默认是JSON方式提交。如果是form方式提交，需要通过$qs进行格式化
headers中加入JWT验证字符串
*/
Vue.prototype.post = function (_url, _params, _cb, _contentType, _loadingcb) {
  let _this = this
  if (_loadingcb == null || _loadingcb === undefined) {
    _this.setLoading('show')
  } else {
    _loadingcb('show')
  }
  // form方式提交时，需要将数据通过qs格式化
  if (_contentType && _contentType === 'form') {
    _params = _this.$qs.stringify(_params)
  }
  _this.$http.post(_url, _params, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
      'AccountId': sessionStorage.getItem('operator_id') == null ? '' : sessionStorage.getItem('operator_id')
    }
  }).then(function (res) {
    _cb(res)
    if (_loadingcb == null || _loadingcb === undefined) {
      _this.setLoading('hide')
    } else {
      _loadingcb('hide')
    }
  }).catch(err => {
    console.log(err)
    if (err.response.status === 401) {
      _this.$message.error('由于您长时间未操作系统，出于安全因素，请您重新登录')
      _this.logout()
      _this.setLoading('hide')
    }
  })
}

Vue.prototype.get = function (_url, _params, _cb, _loadingcb) {
  let _this = this
  if (_loadingcb == null || _loadingcb === undefined) {
    _this.setLoading('show')
  } else {
    _loadingcb('show')
  }
  _this.$http.get(_url, {
    params: _params,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
      'AccountId': sessionStorage.getItem('operator_id') == null ? '' : sessionStorage.getItem('operator_id')
    }
  }).then(function (res) {
    _cb(res)
    _this.setLoading('hide')
  }).catch(err => {
    console.log(err)
    if (err.response.status === 401) {
      _this.logout()
      if (_loadingcb == null || _loadingcb === undefined) {
        _this.setLoading('hide')
      } else {
        _loadingcb('hide')
      }
    }
  })
}

Vue.prototype.$jumpInTab = function (_tab, _params) {
  const _name = _tab.name || store.state.activeTabName
  let tabs = store.state.tabs.filter(tab => tab.name === _name)
  if (tabs.length === 0) {
    store.state.tabs.push(_tab)
  } else {
    tabs[0].changedName = _tab.changedName || _tab.name
  }
  if (router.currentRoute.name !== _tab.name) {
    router.replace({
      name: _tab.changedName,
      params: _params || {}
    })
  }
}
// 在当前 tab 中打开
Vue.prototype.$jumpInCurrentTab = function (_changedName, _params) {
  let tab = {
    changedName: _changedName
  }
  this.$jumpInTab(tab, _params)
}

// 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'new_delivery_count') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal)
  }
}

/* 全局的路由守卫，判断登录情况 */
router.beforeEach((to, from, next) => {
  // 判断是否需要登录
  if (to.name !== 'login' && to.name !== 'storage_second' && to.name !== 'storage_third' && to.name !== 'storage_auto') {
    if (sessionStorage.getItem('authorization')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
